import ExploreLargeCard, {
  ExploreLargeCardProps,
} from "@components/ExploreLargeCard"
import ExploreSmallCard, {
  ExploreSmallCardProps,
} from "@components/ExploreSmallCard"
import {
  DesktopOnly,
  MobileOnly,
  TabletAndDesktopOnly,
  TabletOnly,
} from "@utils/MediaQuery"
import * as R from "ramda"
import React from "react"

import {
  Button,
  ButtonWrapper,
  Cards,
  CardWrapper,
  Container,
  Subtitle,
  Title,
  TitleWrapper,
} from "./common"

interface ExploreHighlightBlockProps {
  actionLink: string
  actionText: string
  blockId?: string
  cards: Array<ExploreSmallCardProps>
  featuredCard: ExploreLargeCardProps
  showTags?: boolean
  subtitle?: string
  title: string
  titleColSize?: number
}

const ExploreHighlightBlock: React.FC<ExploreHighlightBlockProps> = ({
  actionLink,
  actionText,
  blockId,
  cards,
  featuredCard,
  showTags,
  subtitle,
  title,
  titleColSize = 3,
}) => {
  const mobileFeaturedCard: ExploreSmallCardProps = {
    image: featuredCard.image,
    link: featuredCard.actionLink || undefined,
    tag: (showTags && featuredCard.highlightText) || undefined,
    title: featuredCard.title,
  }
  const mobileCards = [mobileFeaturedCard, ...R.take(2, cards)]
  const tabletCards = R.take(2, cards)
  return (
    <Container id={blockId || undefined}>
      <TitleWrapper>
        <Title titleColSize={titleColSize}>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TitleWrapper>
      <MobileOnly>
        <Cards>
          {mobileCards.map((card, i) => (
            <CardWrapper key={`mobile-${i}-${card.link}`}>
              <ExploreSmallCard {...card} />
            </CardWrapper>
          ))}
        </Cards>
      </MobileOnly>
      <TabletAndDesktopOnly>
        <ExploreLargeCard
          {...featuredCard}
          centered={!showTags}
          showTags={showTags}
        />
      </TabletAndDesktopOnly>
      <TabletOnly>
        <Cards>
          {tabletCards.map((card, i) => (
            <CardWrapper key={`tablet-${i}-${card.link}`}>
              <ExploreSmallCard {...card} />
            </CardWrapper>
          ))}
        </Cards>
      </TabletOnly>
      <DesktopOnly>
        <Cards>
          {cards.map((card, i) => (
            <CardWrapper key={`desktop-${i}-${card.link}`}>
              <ExploreSmallCard {...card} />
            </CardWrapper>
          ))}
        </Cards>
      </DesktopOnly>
      <ButtonWrapper>
        <Button text={actionText} to={actionLink} />
      </ButtonWrapper>
    </Container>
  )
}

export default ExploreHighlightBlock
